import {
  ManufaturedInventorySuccess,
  UnregisteredInventoryListSuccess,
  RegisteredInventoryListSuccess,
  InventoryFilterSuccess,
} from '../../actionTypes/inventoryActions';
const inititalState = {
  manufacturedInventoryList: [],
  unRegisteredInventoryList: [],
  registeredInventoryList: [],
  inventoryFilterList: {},
};
export const inventoryReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ManufaturedInventorySuccess:
      return {
        ...state,
        manufacturedInventoryList: payload,
      };
    case UnregisteredInventoryListSuccess:
      return {
        ...state,
        unRegisteredInventoryList: payload,
      };
    case RegisteredInventoryListSuccess:
      return {
        ...state,
        registeredInventoryList: payload,
      };
    case InventoryFilterSuccess:
      return {
        ...state,
        inventoryFilterList: payload,
      };
    default:
      return state;
  }
};
